import React, { useState } from 'react';
import axios from 'axios'; 
import Header from '../components/Header';
import Footer from '../components/Footer';
import { ToastContainer, toast } from "react-toastify";
import foto from '../images/Privacy policy-rafiki.png';

const ChangePassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post('https://api.theonlysale.com/api/request-password-reset', { email });
      toast.success('Password reset email sent successfully!');
      setEmail('');
    } catch (error) {
      toast.error(error.response?.data?.error || 'An error occurred, please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <section className="bg-gray-50 dark:bg-gray-900 h-screen">
        <div className="flex flex-col md:flex-row items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
          <div className="w-full md:w-1/2 flex items-center justify-center p-4">
            <img
              className="w-full h-auto max-w-md"
              src={foto}
              alt="Request Password Reset"
            />
          </div>
          
          <div className="w-full md:w-1/2 bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
            <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
              <h2 className="mb-4 text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                Request Password Reset
              </h2>
              <form className="space-y-4" onSubmit={handleSubmit}>
                <div>
                  <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    Your email
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="name@something.com"
                    required
                  />
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
                >
                  {loading ? 'Sending...' : 'Reset password'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <ToastContainer />
    </>
  );
};

export default ChangePassword;
